// File Path: web/workery-frontend/src/constants/OrderIncident.js

// Order Incident Initiator Types
export const ORDER_INCIDENT_INIATOR_CLIENT = 1;
export const ORDER_INCIDENT_INIATOR_ASSOCIATE = 2;
export const ORDER_INCIDENT_INIATOR_STAFF = 3;
